import { Route, Routes } from "react-router-dom";
import PublicForm from "./pages/PublicForm";
import ThankYou from "./pages/ThankYou";
import Events from "./pages/Events";
import Donate from "./pages/Donate";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import AdminVisitDetail from "./pages/AdminVisitDetail";
import AdminOrders from "./pages/AdminOrders";
import AdminOrderDetail from "./pages/AdminOrderDetail";
import AdminUsers from "./pages/AdminUsers";
import Layout from "./components/Layout";
import AdminLayout from "./components/AdminLayout";

export default function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<PublicForm />} />
        <Route path="/events" element={<Events />} />
        <Route path="/donate" element={<Donate />} />
        <Route path="/thank-you" element={<ThankYou />} />
      </Route>
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route element={<AdminLayout />}>
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/admin/visits/:id" element={<AdminVisitDetail />} />
        <Route path="/admin/donations" element={<AdminOrders />} />
        <Route path="/admin/donations/:id" element={<AdminOrderDetail />} />
        <Route path="/admin/users" element={<AdminUsers />} />
      </Route>
    </Routes>
  );
}
